<div fxLayout="row"
     style=" font-size: 22px; font-family: 'Century Gothic', sans-serif; color: var(--primary); letter-spacing: -0.02rem;">
    {{notificationTitle}}
</div>

<!-- Tab Groups -->
<div fxLayout="row" class="pendingForms" fxShow.gt-sm fxHide.lt-md>
    <mat-tab-group #tabs fxFlex style="width:300px;">
        <mat-tab *ngFor="let child of children">


            <!--             Child name and notification badge -->
            <ng-template mat-tab-label>
                <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">
                    {{childrenDisplayName(child)}} &nbsp; &nbsp;
                    <label [matBadge]="childNotification(child).toString()"
                           [matBadgeHidden]="showNotificationToChild(child)"
                           matBadgeColor="warn" matBadgePosition="above after" class="notificationButton"></label>
                </div>
            </ng-template>
            <!--             -->

            <!-- tab content -->
            <div fxLayout="row" fxLayoutGap="10px" #tabElement style="margin-left: 5px; margin-bottom: 20px;">
                <div fxFlex="100" fxLayoutAlign="start center center" fxLayout="row wrap"
                     fxLayoutAlign.lt-md="center center center">

                    <!--          Consents-->
                    <div class="consentCard mat-elevation-z5" *ngFor="let consent of child.notifications">

                        <div *ngIf="consent.mode === 'consent'" style="height:80px;  padding:10px; background-color: #f7f7f7;">
                            <mat-card-title style="font-size:16px;">{{consent.title}}</mat-card-title>
                            <mat-card-subtitle style="font-size:14px">Προθεσμία Υποβολής: &nbsp;<span
                                    style="font-size:16px; font-weight: 900">{{consent.deadline ? consent.deadline : '-'}}</span>
                            </mat-card-subtitle>
                        </div>

                        <div *ngIf="consent.mode === 'affirmation'" style="height:80px;  padding:10px; background-color:  #f7f7f7">
                            <mat-card-title style="font-size:16px; color: black;">{{consent.title}}</mat-card-title>
                            <mat-card-subtitle style="font-size:14px; color: black;">Προθεσμία Υποβολής: &nbsp;<span
                                    style="font-size:16px; font-weight: 900">{{consent.deadline ? consent.deadline : '-'}}</span>
                            </mat-card-subtitle>
                        </div>
                        <mat-divider fxLayout="row" style="width: 100%;"></mat-divider>

                        <div style="margin:10px 16px 0 16px">
                            <div fxLayout="column" style="height:90px;">

                                <div fxLayout="column" fxFlex
                                     style="font-family: 'Century Gothic', sans-serif; font-size: 14px;">
                                    {{consent.description}}
                                </div>
                            </div>
                        </div>
                        <div style="width:100%; height:30px;" fxLayoutAlign="center center center">
                            <button (click)="showConsent(consent)" mat-flat-button
                                    style="border:1px solid var(--secondaryBlue); color: var(--secondaryBlue);">Προβολή
                            </button>
                        </div>
                    </div>
                    <!--          -->

                    <!--          Affirmations-->
<!--                    <div class="consentCard mat-elevation-z1" *ngFor="let affirmation of child.affirmations">-->

<!--                        <div style="height:80px;  padding:10px; background-color: var(&#45;&#45;secondaryBlue);">-->
<!--                            <mat-card-title style="font-size:16px; color:white;">{{affirmation.title}}</mat-card-title>-->
<!--                            <mat-card-subtitle style="font-size:14px; color:white;">Προθεσμία Υποβολής: &nbsp;<span-->
<!--                                    style="font-size:16px; font-weight: 900; color:white;">{{affirmation.hasDeadline === 1 ? affirmation.deadline_date : '-'}}</span>-->
<!--                            </mat-card-subtitle>-->
<!--                        </div>-->

<!--                        <mat-divider fxLayout="row" style="width: 100%;"></mat-divider>-->

<!--                        <div style="margin:10px 16px 0 16px">-->
<!--                            <div fxLayout="column" style="height:90px;">-->

<!--                                <div fxLayout="column" fxFlex-->
<!--                                     style="font-family: 'Century Gothic', sans-serif; font-size: 14px;">-->
<!--                                    {{affirmation.subtitle}}-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div style="width:100%; height:30px;" fxLayoutAlign="center center center">-->
<!--                            <button (click)="completeAffirmation(child, affirmation)" mat-flat-button-->
<!--                                    style="border:1px solid var(&#45;&#45;secondaryBlue); color: var(&#45;&#45;secondaryBlue);">Προβολή-->
<!--                            </button>-->
<!--                        </div>-->
<!--                    </div>-->
                    <!--          -->

                    <!--          Announcements-->
                    <div class="consentCard mat-elevation-z1" *ngFor="let announcement of child.announcements">

                        <div style="height:80px;  padding:10px; background-color: #f7f7f7;">
                            <mat-card-title style="font-size:16px;">{{announcement.title}}</mat-card-title>
<!--                            <mat-card-subtitle style="font-size:14px; color:white;">Προθεσμία Υποβολής: &nbsp;<span-->
<!--                                    style="font-size:16px; font-weight: 900; color:white;">{{affirmation.hasDeadline === 1 ? affirmation.deadline_date : '-'}}</span>-->
<!--                            </mat-card-subtitle>-->
                        </div>

                        <mat-divider fxLayout="row" style="width: 100%;"></mat-divider>

                        <div style="margin:10px 16px 0 16px">
                            <div fxLayout="column" style="height:90px;">

                                <div fxLayout="column" fxFlex
                                     style="font-family: 'Century Gothic', sans-serif; font-size: 14px;">
                                    {{announcement.description}}
                                </div>
                            </div>
                        </div>
                        <div style="width:100%; height:30px;" fxLayoutAlign="center center center">
                            <button mat-flat-button (click)="showAnnouncement(announcement)"
                                    style="border:1px solid var(--secondaryBlue); color: var(--secondaryBlue);">Προβολή
                            </button>
                        </div>
                    </div>
                    <!--          -->
                    <div *ngIf="childNotification(child) === 0" fxLayout="column" class="card" style="height:450px;"
                         fxFlex>

                        <div style="margin-top:50px; margin-left:auto; margin-right:auto;">
                            <img src="assets/images/noInfo2.png" style="width:150px; height:150px;" alt="noInfo"/>
                        </div>
                        <div
                                style="font-family: 'Century Gothic', 'Helvetica Neue', sans-serif; font-weight: normal; font-size: 18px; margin-left:auto; margin-right:auto;">
                            Δεν υπάρχουν διαθέσιμες δηλώσεις προς συμπλήρωση
                        </div>

                    </div>
                </div>
            </div>
            <!-- -->

        </mat-tab>
    </mat-tab-group>
</div>

<div fxLayout="column" fxShow.lt-md fxHide.gt-sm style="margin-top: 20px;">
    <div fxLayout="row" fxFlex>
        <mat-form-field appearance="fill" style="width:100%;">
            <mat-label>Επιλέξτε χρήστη</mat-label>
            <mat-select [(value)]="selectChildIndex">
                <mat-select-trigger>
                    <mat-icon fxFlexAlign="center" [ngStyle]="{'color': getNotificationColor(selectChildIndex)}">
                        notifications
                    </mat-icon>
                    {{childrenDisplayName(selectChildIndex)}}</mat-select-trigger>
                <mat-option *ngFor="let child of children" [value]="child">
                    <mat-icon [ngStyle]="{'color': getNotificationColor(child)}">notifications</mat-icon>
                    {{childrenDisplayName(child)}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div fxLayout="row">
        <div fxLayout="row" fxLayoutGap="10px" #tabElement>
            <div fxFlex="100" fxLayoutAlign="space-evenly" fxLayout="row wrap"
                 fxLayoutAlign.lt-md="center center center">


                <div class="consentCard mat-elevation-z3" *ngFor="let consent of selectChildIndex.notifications">

                    <div style="height:80px;  padding:10px; background-color: #f7f7f7;">
                        <mat-card-title
                                style="font-size:12px; font-family: 'Century Gothic', 'Helvetica Neue', sans-serif">{{consent.title}}</mat-card-title>
                        <mat-card-subtitle style="font-size:12px">Προθεσμία Υποβολής: &nbsp;<span
                                style="font-size:16px; font-weight: 900">{{consent.deadline ? consent.deadline : '-'}}</span>
                        </mat-card-subtitle>
                    </div>

                    <mat-divider fxLayout="row" style="width: 100%;"></mat-divider>

                    <mat-card-content style="margin:10px 16px 0 16px">
                        <div fxLayout="column" style="height:90px;">

                            <div fxLayout="column" fxFlex
                                 style="font-family: 'Century Gothic', sans-serif; font-size: 14px;">
                                {{consent.description}}
                            </div>
                        </div>
                    </mat-card-content>
                    <div style="width:100%; height:30px;" fxLayoutAlign="center center center">
                        <button (click)="showConsent(consent)" mat-flat-button
                                style="border:1px solid var(--secondaryBlue); color: var(--secondaryBlue);">Προβολή
                        </button>
                    </div>
                </div>

                <div class="consentCard mat-elevation-z3" *ngFor="let affirmation of selectChildIndex.affirmations">

                    <div style="height:80px;  padding:10px; background-color: #f7f7f7;">
                        <mat-card-title
                                style="font-size:12px; font-family: 'Century Gothic', 'Helvetica Neue', sans-serif">{{affirmation.title}}</mat-card-title>
                        <mat-card-subtitle style="font-size:12px">Προθεσμία Υποβολής: &nbsp;<span
                                style="font-size:16px; font-weight: 900">{{affirmation.hasDeadLine ? affirmation.deadline_date : '-'}}</span>
                        </mat-card-subtitle>
                    </div>

                    <mat-divider fxLayout="row" style="width: 100%;"></mat-divider>

                    <mat-card-content style="margin:10px 16px 0 16px">
                        <div fxLayout="column" style="height:90px;">

                            <div fxLayout="column" fxFlex
                                 style="font-family: 'Century Gothic', sans-serif; font-size: 14px;">
                                {{affirmation.subtitle}}
                            </div>
                        </div>
                    </mat-card-content>
                    <div style="width:100%; height:30px;" fxLayoutAlign="center center center">
                        <button (click)="completeAffirmation(selectChildIndex, affirmation)" mat-flat-button
                                style="border:1px solid var(--secondaryBlue); color: var(--secondaryBlue);">Προβολή
                        </button>
                    </div>
                </div>

                <div *ngIf="childNotification(selectChildIndex) === 0" fxLayout="column" class="card"
                     style="height:450px;"
                     fxFlex>

                    <div style="margin-top:50px; margin-left:auto; margin-right:auto;">
                        <img src="assets/images/noInfo2.png" style="width:150px; height:150px;" alt="noInfo"/>
                    </div>
                    <div
                            style="font-family: 'Century Gothic', 'Helvetica Neue', sans-serif; font-weight: normal; font-size: 18px; margin-left:auto; margin-right:auto;">
                        Δεν εχετε εκκρεμείς αιτήσεις
                    </div>

                </div>
            </div>
        </div>
    </div>

</div>
<!--  -->
